import type { LayoutType } from 'types';
import type { TranslationName } from 'types/translator';
import type { TemplateFormsState } from '../index';
import { findTemplateSectionIndex } from '../utils/nameUniqueness';

interface Payload {
  sectionName: string;
  subTabId: string | null;
  newSubTabName: string;
  newSubTabTranslations: TranslationName[];
  layoutType: LayoutType;
  tabId?: string | null;
}

export const renameSubTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { sectionName, subTabId, newSubTabName, newSubTabTranslations, layoutType, tabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = findTemplateSectionIndex(sections, sectionName, tabId);
  if (sectionIndex === -1) return;

  const section = sections[sectionIndex];

  if (subTabId === null) {
    const subTabs = section.subTabs ?? [];
    if (subTabs.some((st) => st.name === newSubTabName)) {
      throw new Error('exists');
    }
    const newId = crypto.randomUUID();
    // Insert the converted default tab at the front (order 0) since the
    // default tab always renders first.
    section.subTabs = [
      { id: newId, order: 0, name: newSubTabName, translations: newSubTabTranslations },
      ...subTabs.map((st) => ({ ...st, order: st.order + 1 })),
    ];
    section.items = section.items.map((item) => ((item.subTabId ?? null) === null ? { ...item, subTabId: newId } : item));
    return;
  }

  if (!section.subTabs) return;

  const subTabIndex = section.subTabs.findIndex((st) => st.id === subTabId);
  if (subTabIndex === -1) return;

  section.subTabs[subTabIndex] = {
    ...section.subTabs[subTabIndex],
    name: newSubTabName,
    translations: newSubTabTranslations,
  };
};
